'use strict';

angular.module('systemOwnerReviewControllers.DecommissionSystems')

.controller('SideBarDecommissionSystemsController', ['$scope', 'authLogin', 'allSystemTypes', 'systemsToReview', function ($scope, authLogin, allSystemTypes, systemsToReview) {

    $scope.sideBarSystemTypes = _.chain(systemsToReview)
                                 .map(function (system) {
                                     return system.SystemTypeID;
                                 })
                                 .uniq()
                                 .map(function (systemTypeID) {
                                     var systemType = _.find(allSystemTypes, { SystemTypeID: systemTypeID });

                                     systemType.IsReviewed = _.findIndex(systemsToReview, {
                                         SystemTypeID: systemTypeID,
                                         IsReviewed: false
                                     }) === -1;

                                     return systemType;
                                 })
                                 .value();

}]);
